// 资产
import tool from '@/views/assets'
export default {
  path: '/assets',
  name: 'assets',
  component: tool,
  meta: {
    keepAlive: true,
    title: '资产',
    // code: 'page:report',
    activeName: '/assets',
    permission: 'property',
    name: 'materialLibrary'
  },
  children: [
    {
      path: 'material',
      name: 'material',
      component: resolve => require(['@/views/material'], resolve),
      meta: {
        keepAlive: true,
        title: '创意素材',
        iconName: 'icon-material',
        permission: 'creativity:image',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'materialLibrary',
          title: '素材库'

        },
        {
          name: 'titleLibrary',
          title: '标题库'
        },
        {
          name: 'creativeComponents',
          title: '创意组件'
        },
        {
          name: 'materialReviewLog',
          title: '素材预审'
        }
      ],
      children: [
        {
          path: 'materialLibrary',
          name: 'materialLibrary',
          component: resolve => require(['@/views/material/materialLibrary'], resolve),
          meta: {
            parents: 'material',
            keepAlive: true,
            title: '素材库',
            iconName: 'icon-material',
            permission: 'image',
            subMenuShow: false
          }
        },
        {
          path: 'titleLibrary',
          name: 'titleLibrary',
          component: resolve => require(['@/views/material/titleLibrary'], resolve),
          meta: {
            parents: 'material',
            keepAlive: true,
            title: '标题库',
            iconName: 'icon-title',
            permission: 'title',
            subMenuShow: false
          }
        },
        {
          path: 'creativeComponents',
          name: 'creativeComponents',
          component: resolve => require(['@/views/putin/creativeComponents/creativeComponents'], resolve),
          meta: {
            parents: 'material',
            keepAlive: true,
            title: '创意组件',
            iconName: 'icon-chuangyizujian-copy',
            permission: 'keywords',
            subMenuShow: false
          }
        },
        {
          path: 'materialReviewLog',
          name: 'materialReviewLog',
          component: resolve => require(['@/views/material/materialReviewLog'], resolve),
          meta: {
            parents: 'material',
            keepAlive: true,
            title: '素材预审',
            iconName: '',
            subMenuShow: false
          }
        }
      ]
    },
    {
      path: 'directional',
      name: 'directional',
      component: resolve => require(['@/views/putin/directional'], resolve),
      meta: {
        keepAlive: true,
        title: '定向',
        iconName: 'icon-dingxiangguanli',
        permission: 'orient',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'directionalManage',
          title: '定向包'

        },
        {
          name: 'crowdManage',
          title: '人群包'
        }
      ],
      children: [
        {
          path: 'directionalManage',
          name: 'directionalManage',
          component: resolve => require(['@/views/putin/directional/directionalManage'], resolve),
          meta: {
            parents: 'directional',
            keepAlive: true,
            title: '定向包',
            iconName: 'icon-dingxiangguanli',
            permission: 'directional'
          },
          children: [
            {
              path: 'addDirectionalManage',
              name: 'addDirectionalManage',
              component: resolve => require(['@/views/putin/directionalManage/addDirectionalManage'], resolve),
              meta: {
                keepAlive: true,
                title: '新建定向包'
              }
            },
            {
              path: 'addBaseDirectional',
              name: 'addBaseDirectional',
              component: resolve => require(['@/views/putin/directionalManage/addBaseDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建基础定向包'
              }
            },
            {
              path: 'addReleasedDirectional',
              name: 'addReleasedDirectional',
              component: resolve => require(['@/views/putin/directionalManage/addReleasedDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建投放定向包'
              }
            },
            {
              path: 'addDirectional',
              name: 'addDirectional',
              component: resolve => require(['@/views/putin/directionalManage/addDirectional'], resolve),
              meta: {
                keepAlive: true,
                title: '新建定向包'
              }
            }
          ]
        },
        {
          path: 'crowdManage',
          name: 'crowdManage',
          component: resolve => require(['@/views/putin/crowdManage'], resolve),
          meta: {
            parents: 'directional',
            keepAlive: true,
            title: '人群包',
            iconName: 'icon-renqunguanli',
            permission: 'crowd'
          }
        }
      ]

    },
    {
      path: 'chengzi',
      name: 'chengzi',
      component: resolve => require(['@/views/assets/chengzi'], resolve),
      meta: {
        keepAlive: true,
        title: '橙子落地页',
        iconName: 'icon-icon-test'
        // permission: 'adConvert'
      }
    },
    {
      path: 'nzapp',
      name: 'nzapp',
      component: resolve => require(['@/views/assets/nzapp'], resolve),
      meta: {
        keepAlive: true,
        title: '应用',
        iconName: 'icon-qingyingyongxuanzhong'
        // permission: 'adConvert'
      }
    },
    {
      path: 'eventManagement',
      name: 'eventManagement',
      component: resolve => require(['@/views/assets/eventManagement'], resolve),
      meta: {
        keepAlive: true,
        title: '事件管理',
        iconName: 'icon-shijianguanli'
        // permission: 'adConvert'
      }
    },
    {
      path: 'conversionTracking',
      name: 'conversionTracking',
      component: resolve => require(['@/views/putin/conversionTracking'], resolve),
      meta: {
        keepAlive: true,
        title: '转化跟踪',
        iconName: 'icon-zhuanhuaxufang',
        permission: 'adConvert'
      }
    },
    {
      path: 'channelManage',
      name: 'channelManage',
      component: resolve => require(['@/views/putin/channelManage'], resolve),
      meta: {
        keepAlive: true,
        title: '渠道管理',
        iconName: 'icon-qudaoguanli',
        permission: 'keywords'
      }
    },
    {
      path: 'labelPackage',
      name: 'labelPackage',
      component: resolve => require(['@/views/putin/label/labelPackage'], resolve),
      meta: {
        keepAlive: true,
        title: '标签包',
        iconName: 'icon-biaoqianbao',
        permission: 'tagPack'
      }
    },
    {
      path: 'filterwords',
      name: 'filterwords',
      component: resolve => require(['@/views/material/filterwordsLibrary'], resolve),
      meta: {
        keepAlive: true,
        title: '屏蔽词库',
        iconName: 'icon-cidian',
        permission: 'blackWord'
      }
    },
    {
      path: 'goodsLibrary',
      name: 'goodsLibrary',
      component: resolve => require(['@/views/assets/goodsLibrary'], resolve),
      meta: {
        keepAlive: true,
        title: '商品库',
        iconName: 'icon-cidian'
      },
      children: [
        {
          path: 'goodsLibraryDetails',
          name: 'goodsLibraryDetails',
          component: resolve => require(['@/views/assets/goodsLibrary/goodsLibraryDetails'], resolve),
          meta: {
            keepAlive: true,
            title: '商品详情'
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/assets.js